import { IntlShape } from "react-intl"
import { ExistingPreAuth } from "../../state/useExistingPreAuth"
import { PreAuthResponse } from "../../state/useCreatePreAuth"
import { PreAuthAnswersResponse } from "../../state/usePreAuthAnswers"

type PreAuthObject = Exclude<ExistingPreAuth | PreAuthResponse | PreAuthAnswersResponse, "createdDate"> & {
  createdDate?: string
}
interface FormattedPreAuthAmounts {
  carrotCardAmount: string
  personalPaymentAmount: string | null
  expirationDate: string
  createdDate?: string
}

export function getAmountsAndDates(preAuth: PreAuthObject, intl: IntlShape): FormattedPreAuthAmounts {
  const coveredSwipeAmount = preAuth?.coveredSwipeAmount / 100
  const memberOOPAmount = preAuth?.memberOOPAmount / 100

  const formattedCarrotCardAmount = intl.formatNumber(coveredSwipeAmount, {
    style: "currency",
    currency: preAuth?.currencyCode,
    currencyDisplay: "narrowSymbol"
  })

  const formattedPersonalPaymentAmount = memberOOPAmount
    ? intl.formatNumber(memberOOPAmount, {
        style: "currency",
        currency: preAuth?.currencyCode,
        currencyDisplay: "narrowSymbol"
      })
    : null

  const expirationDate = new Date(preAuth?.expirationDate)
  const formattedExpirationDate = intl.formatDate(expirationDate, {
    year: "numeric",
    month: "long",
    day: "numeric"
  })

  const result: FormattedPreAuthAmounts = {
    carrotCardAmount: formattedCarrotCardAmount,
    personalPaymentAmount: formattedPersonalPaymentAmount,
    expirationDate: formattedExpirationDate
  }

  if (preAuth?.createdDate) {
    const createdDate = new Date(preAuth?.createdDate)
    result.createdDate = intl.formatDate(createdDate, {
      year: "numeric",
      month: "long",
      day: "numeric"
    })
  }

  return result
}
